import * as Sentry from '@sentry/nextjs'
import { CaptureConsole } from '@sentry/integrations'

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN

if (process.env.NODE_ENV === 'production') {
	Sentry.init({
		dsn: SENTRY_DSN,
		tracesSampleRate: process.env.NEXT_PUBLIC_DEPLOYMENT_ENV === 'production' ? 0.1 : 1,
		release: '1.0',
		// ...
		// Note: if you want to override the automatic release value, do not set a
		// `release` value here - use the environment variable `SENTRY_RELEASE`, so
		// that it will also get attached to your source maps
		environment: process.env.NEXT_PUBLIC_DEPLOYMENT_ENV || 'development',
		integrations: [
			new CaptureConsole({
				levels: ['error'],
			}),
		],
	})
}
